// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ldimpEntity from './entities/ldimp.json';
import ldimpMenu from '../pages/ldimp/menu.json';
import ldimpFullForm from '../pages/ldimp/forms/full.json';
import ldimpContextForm from '../pages/ldimp/forms/context.json';
import ldimpMiniForm from '../pages/ldimp/forms/mini.json';
import ldimpLookupForm from '../pages/ldimp/forms/lookup.json';
import ldimpTableView from '../pages/ldimp/views/table.json';
import ldimpStagesView from '../pages/ldimp/views/stages.json';
import ldimpCardsView from '../pages/ldimp/views/cards.json';
import ldimpInlineView from '../pages/ldimp/views/inline.json';
import ldimpBacklogView from '../pages/ldimp/views/backlog.json';
import ldimpSplitView from '../pages/ldimp/views/split.json';
import ldimpCalendarView from '../pages/ldimp/views/calendar.json';
import ldimpDashboardView from '../pages/ldimp/views/dashboard.json';

/** Тип запису «Вплив» зі сторінками пакета: меню, форми та подання з pages/ldimp/. */
export const ldimpDefinition: IRecordTypeDefinition = {
  ...ldimpEntity,
  views: assembleViewSet({
      table: ldimpTableView,
      stages: ldimpStagesView,
      cards: ldimpCardsView,
      inline: ldimpInlineView,
      backlog: ldimpBacklogView,
      split: ldimpSplitView,
      calendar: ldimpCalendarView,
      dashboard: ldimpDashboardView,
  }),
  form: ldimpFullForm,
  forms: { full: ldimpFullForm, context: ldimpContextForm, mini: ldimpMiniForm, lookup: ldimpLookupForm },
  menu: ldimpMenu,
} as IRecordTypeDefinition;
